module.exports = __webpack_public_path__ + "img/scan-qrcode.7e5789a4.svg";